var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 158,
    viewBox: "0 0 327 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#audience_no_data_svg__filter0_d_3603_150531)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 196,
    height: 112,
    rx: 4,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 194,
    height: 110,
    rx: 3,
    stroke: "#6F6F76",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 58.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 83.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 8.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#ADC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 33.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#ADC9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 58.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 83.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 9a.5.5 0 01.5-.5h30a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-30a.5.5 0 01-.5-.5V9z",
    fill: "#EBF3FF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 33.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 58.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 83.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#59F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#audience_no_data_svg__filter1_d_3603_150531)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 44,
    width: 196,
    height: 112,
    rx: 4,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 45,
    width: 194,
    height: 110,
    rx: 3,
    stroke: "#6F6F76",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 52.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 77.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 102.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 127.5,
    width: 91,
    height: 20,
    rx: 0.5,
    fill: "#ADC9FF",
    stroke: "#105ED5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 52.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 77.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 102.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 127.5,
    width: 47,
    height: 20,
    rx: 0.5,
    fill: "#C7DAFF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 52.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 77.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 102.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#59F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 127.5,
    width: 31,
    height: 20,
    rx: 0.5,
    fill: "#EBF3FF",
    stroke: "#59F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "audience_no_data_svg__filter0_d_3603_150531",
    x: 0.5,
    y: 0,
    width: 198,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.435294 0 0 0 0 0.435294 0 0 0 0 0.462745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3603_150531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3603_150531",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "audience_no_data_svg__filter1_d_3603_150531",
    x: 128.5,
    y: 44,
    width: 198,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.435294 0 0 0 0 0.435294 0 0 0 0 0.462745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3603_150531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3603_150531",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceNoData);
export default __webpack_public_path__ + "static/media/audience_no_data.48420177aa23224bba15595ed239a59f.svg";
export { ForwardRef as ReactComponent };